import { Dimensions } from "react-native";

function getPlatformType() {
  const width = Dimensions.get("window").width;
  if (width <= 1024) {
    return "phone";
  } else {
    return "web";
  }
}

export default getPlatformType;

export const validateNumericWithSpaces = (inputValue) => {
  const regex = /^[0-9\s]*$/;
  if (regex.test(inputValue)) {
    return inputValue;
  } else {
    const sanitizedValue = inputValue.replace(/[^0-9\s]/g, '');
    return sanitizedValue;
  }
};